export const SAVE_COMPANY_ID = 'SAVE_COMPANY_ID';
